import { createFileRoute, redirect } from '@tanstack/react-router';
import { headSignupSubRoute } from 'router/utils';

import {
  clearOpportunityPendingLeadId,
  clearSessionStorage,
} from 'config/storage';
import { isVerified } from 'services/partnersSelfSignup/otp';
import {
  getOppQueryKey,
  getOppSummaryQueryOptions,
} from 'services/partnersSelfSignup/opportunity';

export const Route = createFileRoute(
  '/opportunity/$oppId/terms-and-conditions/decline/success/',
)({
  head: headSignupSubRoute,
  beforeLoad: async ({ context, params }) => {
    const { queryClient } = context;
    const { oppId } = params;

    clearOpportunityPendingLeadId(queryClient);

    const summary = await queryClient.query(
      getOppSummaryQueryOptions({ oppId }),
    );

    if (!(await isVerified({ queryClient, email: summary.oppEmail }))) {
      throw redirect({ to: '/' });
    }

    // The decision changed the Opportunity. The summary does not depend on it.
    queryClient.invalidateQueries({
      queryKey: getOppQueryKey({ oppId }),
    });
  },
  loader: async ({ context }) => {
    clearSessionStorage(context.queryClient);
  },
});
